import { arrayOf, Schema } from 'normalizr';
import { transformUtil } from 'js-utils/transformation';

export const DESTINATION_EVENTS_SCHEMA = new Schema('events');

/**
 * Transforms service response specifically for events from destination service
 */
export const transformDestinationEventsData = (data) => {
    const transformedEvents = transformUtil({
        response: data,
        schema: arrayOf(DESTINATION_EVENTS_SCHEMA),
    });

    const events = transformedEvents.result.map(
        (result) => transformedEvents.entities.events[result],
    );

    return {
        events,
    };
};
